import React, { useState, useEffect } from 'react';
import { Languages, X, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

// Language codes to names mapping
const langNames = {
    'hi': 'Hindi',
    'es': 'Spanish',
    'fr': 'French',
    'de': 'German',
    'ar': 'Arabic',
    'pt': 'Portuguese',
    'zh': 'Chinese',
    'ja': 'Japanese',
    'ru': 'Russian',
    'bn': 'Bengali',
    'pa': 'Punjabi',
    'te': 'Telugu',
    'ta': 'Tamil',
    'mr': 'Marathi',
    'gu': 'Gujarati',
    'kn': 'Kannada',
    'ml': 'Malayalam',
}

export default function TranslationBanner() {
    const [isVisible, setIsVisible] = useState(false);
    const [targetLang, setTargetLang] = useState(null);

    useEffect(() => {
        // Check if user has already dismissed it
        if (localStorage.getItem('hide_translation_banner') === 'true') {
            return;
        }

        const checkDetection = () => {
            const lang = sessionStorage.getItem('detected_lang')?.split('-')[0];
            
            // If it's not an English-speaking detected area
            if (lang && lang !== 'en') {
                setTargetLang(lang);
                setIsVisible(true);
            }
        };

        // Check immediately or wait for CountrySelect to finish
        checkDetection();
        
        // Listen for storage changes in case detection happens later
        window.addEventListener('storage', checkDetection);
        return () => window.removeEventListener('storage', checkDetection);
    }, []);

    const handleTranslate = () => {
        const url = window.location.href;
        const translateUrl = `https://translate.google.com/translate?sl=en&tl=${targetLang}&u=${encodeURIComponent(url)}`;
        window.open(translateUrl, '_blank');
    };

    const handleDismiss = () => {
        setIsVisible(false);
        localStorage.setItem('hide_translation_banner', 'true');
    };

    if (!isVisible || !targetLang) return null;

    return (
        <div className="bg-inclusion-gold py-2 px-4 flex items-center justify-between text-black sticky top-0 z-[100] shadow-md animate-in slide-in-from-top duration-300">
            <div className="flex items-center gap-3">
                <div className="bg-black/10 p-1.5 rounded-full">
                    <Languages className="w-5 h-5" />
                </div>
                <p className="text-sm font-medium">
                    View MyEnAb in <span className="font-bold underline">{langNames[targetLang] || targetLang.toUpperCase()}</span>?
                </p>
            </div>
            <div className="flex items-center gap-2">
                <Button 
                    onClick={handleTranslate} 
                    className="h-8 py-0 bg-black text-white hover:bg-black/80 text-xs font-lexend flex items-center gap-1"
                >
                    Translate
                    <ExternalLink className="w-3 h-3" />
                </Button>
                <button 
                    onClick={handleDismiss}
                    className="p-1 hover:bg-black/10 rounded-full transition-colors"
                >
                    <X className="w-5 h-5" />
                </button>
            </div>
        </div>
    );
}
